// 翻译服务 - 适配实验室管理系统的API调用方式
const API_BASE = '/api';

// 辅助函数：获取token
const getToken = () => {
  return localStorage.getItem('token');
};

// 辅助函数：API请求
const apiRequest = async (url: string, options: RequestInit = {}) => {
  const token = getToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string> || {}),
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}${url}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/';
      throw new Error('未授权，请重新登录');
    }
    const error = await response.json().catch(() => ({ message: '请求失败' }));
    throw new Error(error.message || '请求失败');
  }

  return response.json();
};

export interface TranslationRequest {
  text: string;
  fromLang?: string;
  toLang?: string;
  engine?: string;
}

export interface TranslationResponse {
  originalText: string;
  translatedText: string;
  fromLang: string;
  toLang: string;
  engine: string;
}

export const translationService = {
  // 翻译文本
  translate: async (request: TranslationRequest): Promise<TranslationResponse> => {
    const response = await apiRequest('/translate', {
      method: 'POST',
      body: JSON.stringify(request),
    });
    return response.data;
  },

  // 批量翻译
  translateBatch: async (
    texts: string[],
    fromLang: string = 'en',
    toLang: string = 'zh',
    engine: string = 'free'
  ) => {
    const response = await apiRequest('/translate/batch', {
      method: 'POST',
      body: JSON.stringify({
        texts,
        fromLang,
        toLang,
        engine
      }),
    });
    return response.data.results;
  }
};
